// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AppBadgeController from "./app_badge_controller"
application.register("app-badge", AppBadgeController)

import AutopayEnrollController from "./autopay_enroll_controller"
application.register("autopay-enroll", AutopayEnrollController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import BoardArrangeController from "./board_arrange_controller"
application.register("board-arrange", BoardArrangeController)

import BroadcastComposeController from "./broadcast_compose_controller"
application.register("broadcast-compose", BroadcastComposeController)

import BroadcastPollController from "./broadcast_poll_controller"
application.register("broadcast-poll", BroadcastPollController)

import BroadcastSelectController from "./broadcast_select_controller"
application.register("broadcast-select", BroadcastSelectController)

import CardAdjustController from "./card_adjust_controller"
application.register("card-adjust", CardAdjustController)

import CardChargeController from "./card_charge_controller"
application.register("card-charge", CardChargeController)

import ChargeFormController from "./charge_form_controller"
application.register("charge-form", ChargeFormController)

import CheckboxRevealController from "./checkbox_reveal_controller"
application.register("checkbox-reveal", CheckboxRevealController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ConversationSearchController from "./conversation_search_controller"
application.register("conversation-search", ConversationSearchController)

import CreditFormController from "./credit_form_controller"
application.register("credit-form", CreditFormController)

import DismissibleController from "./dismissible_controller"
application.register("dismissible", DismissibleController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import FeedbackController from "./feedback_controller"
application.register("feedback", FeedbackController)

import FeedbackTriggerController from "./feedback_trigger_controller"
application.register("feedback-trigger", FeedbackTriggerController)

import Forms__PermissionTogglerController from "./forms/permission_toggler_controller"
application.register("forms--permission-toggler", Forms__PermissionTogglerController)

import HeroController from "./hero_controller"
application.register("hero", HeroController)

import HoldCountdownController from "./hold_countdown_controller"
application.register("hold-countdown", HoldCountdownController)

import InboxController from "./inbox_controller"
application.register("inbox", InboxController)

import InlineLocationController from "./inline_location_controller"
application.register("inline-location", InlineLocationController)

import LedgerLensController from "./ledger_lens_controller"
application.register("ledger-lens", LedgerLensController)

import MigrationGateController from "./migration_gate_controller"
application.register("migration-gate", MigrationGateController)

import MobileNavScrollController from "./mobile_nav_scroll_controller"
application.register("mobile-nav-scroll", MobileNavScrollController)

import PageHelpController from "./page_help_controller"
application.register("page-help", PageHelpController)

import PlanRecommenderController from "./plan_recommender_controller"
application.register("plan-recommender", PlanRecommenderController)

import PwaInstallController from "./pwa_install_controller"
application.register("pwa-install", PwaInstallController)

import ReadReceiptController from "./read_receipt_controller"
application.register("read-receipt", ReadReceiptController)

import RevealController from "./reveal_controller"
application.register("reveal", RevealController)

import RevenueCalcController from "./revenue_calc_controller"
application.register("revenue-calc", RevenueCalcController)

import ReviewRowsController from "./review_rows_controller"
application.register("review-rows", ReviewRowsController)

import SavingsCalcController from "./savings_calc_controller"
application.register("savings-calc", SavingsCalcController)

import SignatureCanvasController from "./signature_canvas_controller"
application.register("signature-canvas", SignatureCanvasController)

import StripePaymentController from "./stripe_payment_controller"
application.register("stripe-payment", StripePaymentController)

import StripeSetupController from "./stripe_setup_controller"
application.register("stripe-setup", StripeSetupController)

import SubscriptionPeriodTogglerController from "./subscription_period_toggler_controller"
application.register("subscription-period-toggler", SubscriptionPeriodTogglerController)

import TemplatePreviewController from "./template_preview_controller"
application.register("template-preview", TemplatePreviewController)

import ThreadController from "./thread_controller"
application.register("thread", ThreadController)

import ThrottleNoticeController from "./throttle_notice_controller"
application.register("throttle-notice", ThrottleNoticeController)

import UnitMixCalcController from "./unit_mix_calc_controller"
application.register("unit-mix-calc", UnitMixCalcController)

import WebPushController from "./web_push_controller"
application.register("web-push", WebPushController)

import UnitTransferController from "./unit_transfer_controller"
application.register("unit-transfer", UnitTransferController)
